import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'
import ContainerPublic from '../base/ContainerPublic'
import { GrUserNew } from 'react-icons/gr'
import { FaLockOpen } from "react-icons/fa6";
import Footer from '../base/Footer'
import useAuth from '../../configurations/auth/publicUsers/useAuth'
import FabToggle from '../base/FabToggle'
import { IsMobileEnv } from '../../configurations/initUrls'
import PublicUserMenu from './publicUsers/PublicUserMenu'

export default function MasterPage({ children }) {
    const { authentication, logedOut } = useAuth()
    return (
        <ContainerPublic >
            <div className="bg-slate-100 min-h-screen flex flex-col justify-between  text-gray-800">
                <div className="fixed w-full z-40 bg-white/90 backdrop-blur-xl border-b border-gray-100 shadow-soft py-2.5 pe-4 mb-4 flex gap-2 justify-between items-center">
                    <Link to="/" className='ms-3 flex items-center'>
                        <img
                            alt="Doctora OPD"
                            src="/assets/images/logo.svg"
                            className="h-7 sm:h-8 w-auto"
                        />
                    </Link>
                    <div className='flex items-end'>
                        {/* <Link to="/create-doctor">
                            <button className="text-sm flex justify-center items-end py-1 pe-2 hover:text-blue-800 text-blue-600 ">
                                <span className='hidden sm:block ms-1'>Register as Doctor?</span>
                                <span className='sm:hidden ms-1'>Register?</span>
                            </button>
                        </Link> */}
                        {authentication.isLogin ?
                            <PublicUserMenu />
                            :
                            <Link to="/login">
                                <button
                                    className="group relative inline-flex items-center overflow-hidden rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-medium text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-600 hover:shadow-lg"
                                >
                                    <span className="absolute left-4 -translate-x-4 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100">
                                        <FaLockOpen className="text-sm" />
                                    </span>

                                    <span className="transition-all duration-300 group-hover:pl-5">
                                        Login
                                    </span>
                                </button>
                            </Link>
                        }
                    </div>
                </div>
                <div className='pt-[61px]'></div>
                <div className='page-enter'>{children}</div>


                {!IsMobileEnv ?
                    <section>
                        <Footer />
                    </section>
                    : <div className='p-10 bg-slate-100' /> 
                }
            </div >

            <FabToggle />
        </ContainerPublic >
    )
}
